const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecording(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    fill: "#E53E3E",
    style: {
      fill: "#E53E3E",
      fill: "color(display-p3 0.8980 0.2431 0.2431)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.5,
    stroke: "#E53E3E",
    style: {
      stroke: "#E53E3E",
      stroke: "color(display-p3 0.8980 0.2431 0.2431)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#E53E3E",
    style: {
      stroke: "#E53E3E",
      stroke: "color(display-p3 0.8980 0.2431 0.2431)",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.20317c05edc0196180f673cc41ac110e.svg";
export { ForwardRef as ReactComponent };